export default {
  state: {
    dataList: [
      // {
      //   id: '11',
      //   name: "产品管理",
      //   text: "该系统实现了对产品的类别、产品参数模板、产品基础信息的维护管理查询统计功能，可通过系统对每一个产品赋予工业互联网标识码，产品再后期销售、运输、使用等各个个环节的操作记录均可记录在当前产品的标识码下，基于工业互联网标识码为产品建立全生命周期档案。",
      //   html: `该系统实现了对产品的类别、产品参数模板、产品基础信息的维护管理查询统计功能，可通过系统对每一个产品赋予工业互联网标识码，产品再后期销售、运输、使用等各个个环节的操作记录均可记录在当前产品的标识码下，基于工业互联网标识码为产品建立全生命周期档案。`,
      //   contact: "kfxxwl@163.com",
      //   img: require("@/assets/images/home/panel_a_m_01.png"),
      // },
      // {
      //   id: '12',
      //   name: "设备管理",
      //   text: "设备管理系统统可帮助企业更好的管理设备，从采购环节开始为每一台设备赋予工业互联网标识码，在该码下记录并管理与设备相关的每一条数据，围绕设备的、安装、使用、报废、对设备备件的采购、库存、领用、归还等信息进行管理。为每个设备建立设备台账，包括设备的基础信息、设备运行状态、设备位置等提高设备利用率和安全性，帮助企业更好的管理设备提高管理效率。",
      //   html: `设备管理系统统可帮助企业更好的管理设备，从采购环节开始为每一台设备赋予工业互联网标识码，在该码下记录并管理与设备相关的每一条数据，围绕设备的、安装、使用、报废、对设备备件的采购、库存、领用、归还等信息进行管理。为每个设备建立设备台账，包括设备的基础信息、设备运行状态、设备位置等提高设备利用率和安全性，帮助企业更好的管理设备提高管理效率。`,
      //   contact: "kfxxwl@163.com",
      //   img: require("@/assets/images/home/panel_a_m_02.png"),
      // },
      // {
      //   id: '13',
      //   name: "运维管理",
      //   text: "系统对企业设备进行分类、对每一个设备赋予工业互联网标识码，设备的监控、保养、巡检、报修、维修等工作可直接通过扫码操作完成实时上报数据到平台，帮助企业实现设备的监控、归档、查询等管理。提高设备的可靠性和稳定性，降低设备故障率和维修成本，提高企业的生产效率和经济效益。",
      //   html: `系统对企业设备进行分类、对每一个设备赋予工业互联网标识码，设备的监控、保养、巡检、报修、维修等工作可直接通过扫码操作完成实时上报数据到平台，帮助企业实现设备的监控、归档、查询等管理。提高设备的可靠性和稳定性，降低设备故障率和维修成本，提高企业的生产效率和经济效益。`,
      //   contact: "kfxxwl@163.com",
      //   img: require("@/assets/images/home/panel_a_m_03.png"),
      // },
      // {
      //   id: '14',
      //   name: "组织管理",
      //   text: "组织管理系统是一种用于管理企业组织架构、人员信息、工作流程、任务分配的软件系统。它可以帮助企业实现组织管理的自动化和信息化，提高组织管理的效率和精度，降低管理成本和风险。系统包括以下功能（组织架构管理、人员信息管理、工作流程管理、任务分配管理、绩效考核管理、培训管理）帮助企业实现组织管理的全面升级，提高组织的适应性和竞争力，是企业管理的重要工具。",
      //   html: `组织管理系统是一种用于管理企业组织架构、人员信息、工作流程、任务分配的软件系统。它可以帮助企业实现组织管理的自动化和信息化，提高组织管理的效率和精度，降低管理成本和风险。系统包括以下功能（组织架构管理、人员信息管理、工作流程管理、任务分配管理、绩效考核管理、培训管理）帮助企业实现组织管理的全面升级，提高组织的适应性和竞争力，是企业管理的重要工具。`,
      //   contact: "kfxxwl@163.com",
      //   img: require("@/assets/images/home/panel_a_m_04.png"),
      // }
    ]
  },
}
